import React, { Component } from 'react';
import './KPI4.css';

import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import KPIs from '../KPIs';
import moment from 'moment';
import { getDateTimeString } from '@acri-tools/react-tools/utils/date';

import Chart from 'chart.js';
import { Line } from 'react-chartjs-2';
import * as zoomPlugin from 'chartjs-plugin-zoom';
import { complete_bar_data_start, complete_bar_data_stop, default_options } from '../../../_utils/graphs';
import { date_day_diff, date_timezone_compensated, get_month_dates, is_on_kpi_page, update_kpi_url } from '../../../_utils/kpi';
import { API_URL, axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import request from '@acri-tools/react-tools/utils/request';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import KPITable from '../../../components/KPITable/KPITable';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { to_local_iso_string } from '../../../_utils/date';
import KPIRefreshOverlay from '../../../components/KPIRefreshOverlay/KPIRefreshOverlay';
Chart.plugins.register(zoomPlugin);

interface Props {
    kpi?:any
}
interface State {
    loading: boolean
    refreshing: boolean
    startDate: string
    stopDate: string
    updateStartDate: string
    updateStopDate: string
    base_startDate?: string
    base_stopDate?: string

    api: boolean
    dashboard: boolean

    api_data?: any,
    dashboard_data?: any,

    drag_mode?: boolean
    // export
    json_format: boolean
}


/**
 * 1. KPIS SELECT
 * 2. KPI Type select (dashboard, API)
 * 3. Graph 1 graph per selected (toggle dashboard / API / all)
 *      1 or 0 bar like
 */


class KPI4 extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            json_format: false,
            refreshing: false,
            loading: false,
            api: true,
            dashboard: true,
            ...this.default_values(true)
        }
    }
    default_values = (set_base?:boolean) => {
        return {
            ...get_month_dates( this.state, set_base )
        }
    }
    componentDidMount() {
        this.fetch_data(true)
    }
    async componentDidUpdate(prevProps:Props) {
        if(prevProps.kpi?.refresh !== this.props.kpi?.refresh){
            await this.setState({
                ...this.default_values(true)
            })
            if(is_on_kpi_page(4)){
                this.update_url()
            }
            this.fetch_data(true)
        }
    }


    fetch_data = async(refresh?:boolean) => {
        if(refresh) this.setState({ refreshing: true, loading:true });
        else this.setState({ loading:true });
        try {
            let promises = [];
            if(this.state.api)
                promises.push(this.fetch_service_data('api'))
            if(this.state.dashboard)
                promises.push(this.fetch_service_data('dashboard'))
            
            await Promise.all(promises);
        }
        catch (e) {
        }
        finally {
            // this.setState({ loading: false })
            if(refresh) this.setState({ refreshing: false, loading:false });
            else this.setState({ loading:false });
        }
    }
    fetch_service_data = async(service:'api'|'dashboard') => {
        try {
            let res = await request(`${API_URL}/api/v1/dashboard`,{
                method:'get',
                responseType:'json',
                serializer:'json',
                params:{
                    limit: 4500,
                    filter: `service eq '${service === 'api' ? 'API' : 'dashboard'}'
                    and date_time ge '${this.state.startDate}' and date_time le '${this.state.stopDate}'`,
                    orderby: 'date_time DESC'
                }
            })
            let update:any = {};
            update[`${service}_data`] = res.data.value;
            this.setState(update);
        }
        catch (e) {
            axiosErrorHandler( e, { 
                functionName: 'fetch_kpi_data'
            })
        }
    }

    applyChanges = async() =>{
        await this.setState({
            startDate: this.state.updateStartDate,
            stopDate: this.state.updateStopDate
        })
        this.update_url()
        this.fetch_data()
    }

    reset = async() => {
        await this.setState({
            ...this.default_values()
        })
        this.fetch_data(true)
    }
    render() {
        let _state: any = this.state;
        return (
            <KPIs
                title="Dashboard Operations Performance​"
            >
                <div className="row-2">
                    <div className="row-2">
                        <div className="form-field">
                            <label>Start Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStartDate}
                                onChange={async(e) => { 
                                    await this.setState({ updateStartDate: e.target.value })
                                    // this.fetch_data(true);
                                }}
                            />
                        </div>
                        <div className="form-field">
                            <label>Stop Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStopDate}
                                onChange={async(e) => {
                                    await this.setState({ updateStopDate: e.target.value });
                                    // this.fetch_data(true);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className={
                    classNames({
                        "custom-button small alt inline apply-changes": true,
                        "disabled": !(
                            this.state.updateStartDate !== this.state.startDate
                            || this.state.updateStopDate !== this.state.stopDate
                        )
                    })} 
                    onClick={this.applyChanges}
                >
                    <i className="fas fa-check" /> Apply Changes
                </div>


                <div className="custom-button small alt inline" onClick={this.reset}>
                    <i className="fas fa-redo-alt" /> Reset Filters
                </div>
                <br/>
                <br/>
                
                {/* <div className="row-2">
                    <div className="measurements">
                        <div className="form-field">
                            <label>Dashboard service</label>
                        </div>
                        <FormFieldCheckbox
                            notSolid
                            label="All"
                            value={['api', 'dashboard'].every((v) => _state[v])}
                            onChange={(val: boolean) => {
                                this.setState({
                                    api: val,
                                    dashboard: val,
                                })
                            }}
                        />
                        <FormFieldCheckbox
                            notSolid
                            label="API"
                            value={this.state.api}
                            onChange={(api: boolean) => { 
                                this.setState({ api });
                                if(api) this.fetch_service_data('api')
                            }}
                        />
                        <FormFieldCheckbox
                            notSolid
                            label="Dashboard"
                            value={this.state.dashboard}
                            onChange={(dashboard: boolean) => { 
                                this.setState({ dashboard });
                                if(dashboard) this.fetch_service_data('dashboard')
                            }}
                        />
                    </div>

                    <div className="row-2">
                    </div>
                </div>

                <br />
                <br /> */}

                <div className="title-3">Results</div>
                <Tabs
                    tabs={[
                        {
                            label: <><i className="fas fa-chart-bar" /> Graph</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                    <div className="centered">
                                        <Spinner />
                                    </div>
                                    :
                                    <>
                                        <FormFieldCheckbox
                                            notSolid label="Drag Mode"
                                            value={!!this.state.drag_mode}
                                            onChange={(drag_mode: boolean) => { this.setState({ drag_mode }) }}
                                        />       
                                        {/* API */}
                                        {/* {
                                            this.state.api && this.state.api_data &&
                                            <div className="kpi-graph kpi-4-graph">
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <Line
                                                    plugins={[zoomPlugin]}
                                                    options={{
                                                        ...default_options,
                                                        elements: {
                                                            line: {
                                                                tension: 0 // disables bezier curves
                                                            }
                                                        },
                                                        scales: {
                                                            xAxes: [{
                                                                type: 'time',
                                                                ticks: {
                                                                    ...default_options.scales.xAxes.ticks,
                                                                    min: moment(new Date(this.state.startDate)),
                                                                    max: moment(new Date(this.state.stopDate)),
                                                                },
                                                                time: {
                                                                    ...default_options.scales.xAxes.time,
                                                                },
                                                            }],
                                                            yAxes: [{
                                                                ticks: {
                                                                    min: 0,
                                                                    stepSize: 1,
                                                                    max: 1
                                                                },
                                                                scaleLabel: {
                                                                    ...default_options.scales.yAxes.scaleLabel,
                                                                    labelString: 'API availability',
                                                                }
                                                            }],
                                                        },

                                                        zoom: {
                                                            enabled: true,
                                                            onZoomComplete: this.on_zoom_complete,
                                                            drag: this.state.drag_mode,
                                                            wheel: !this.state.drag_mode,
                                                            mode: 'x',
                                                        },
                                                    }}
                                                    data={{
                                                        labels: ['API availability'],
                                                        datasets: [
                                                            {
                                                                steppedLine: 'after',
                                                                label: 'API availability',
                                                                borderColor: 'rgb(11, 206, 99)',
                                                                backgroundColor: 'rgb(11, 206, 99,0.1)',
                                                                data: this.state.api_data ? [
                                                                    // complete_bar_data_stop(this.state.api_data, 'value', this.state.stopDate),
                                                                    ...this.state.api_data?.map((d: any) => {
                                                                        return { y: d.availability ? 1 : 0, x: date_timezone_compensated(d.date_time) };
                                                                    })
                                                                ]: []
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </div>
                                        } */}

                                        {/* DOWNLOAD PERFORMANCE */}
                                        {
                                            this.state.dashboard && this.state.dashboard_data &&
                                            <div className="kpi-graph kpi-3-graph">
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <Line
                                                    plugins={[zoomPlugin]}
                                                    options={{
                                                        ...default_options,
                                                        elements: {
                                                            line: {
                                                                tension: 0 // disables bezier curves
                                                            }
                                                        },
                                                        scales: {
                                                            xAxes: [{
                                                                type: 'time',
                                                                ticks: {
                                                                    ...default_options.scales.xAxes.ticks,
                                                                    min: moment(new Date(this.state.startDate)),
                                                                    max: moment(new Date(this.state.stopDate)),
                                                                },
                                                                time: {
                                                                    ...default_options.scales.xAxes.time,
                                                                },
                                                            }],
                                                            yAxes: [{
                                                                ticks: {
                                                                    min: 0,
                                                                    max:1,
                                                                    stepSize: 1,
                                                                },
                                                                scaleLabel: {
                                                                    ...default_options.scales.yAxes.scaleLabel,
                                                                    labelString: 'Dashboard availability',
                                                                }
                                                            }],
                                                        },

                                                        zoom: {
                                                            enabled: true,
                                                            onZoomComplete: this.on_zoom_complete,
                                                            drag: this.state.drag_mode,
                                                            wheel: !this.state.drag_mode,
                                                            mode: 'x',
                                                        },
                                                    }}
                                                    data={{
                                                        labels: ['Dashboard availability'],
                                                        datasets: [
                                                            {
                                                                steppedLine: 'after',
                                                                label: 'Dashboard availability',
                                                                borderColor: 'rgb(238, 168, 128)',
                                                                backgroundColor: 'rgba(238, 168, 128, 0.1)',
                                                                data: [
                                                                    // complete_bar_data_stop(this.state.dashboard_data, 'value', this.state.stopDate),
                                                                    ...this.state.dashboard_data.map((d: any) => {
                                                                        return { y: d.availability ? 1 : 0, x: date_timezone_compensated(d.date_time) };
                                                                    })
                                                                ]
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </div>
                                        }
                                    </>
                                }

                            </div>
                        },
                        {
                            label: <><i className="fas fa-th-list" /> Data</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                    <div className="centered">
                                        <Spinner />
                                    </div>
                                    :
                                    <>
                                        {
                                            this.state.api && this.state.api_data &&
                                            <KPITable title="API" counter={this.state.api_data?.length}>
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <table className="table-kpi">
                                                    <thead>
                                                        <tr>
                                                            <th>Service</th>
                                                            <th>Date</th>
                                                            <th>Avalibility</th>
                                                            {/* <th>Duration</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.api_data.map((d: any, key: number) => (
                                                                <tr key={key}>
                                                                    <td>{d.service}</td>
                                                                    <td>{d.date_time}</td>
                                                                    <td>{d.availability?.toString()}</td>
                                                                    {/* <td>{date_day_diff(d.start, d.stop || new Date().toISOString())}</td> */}
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </KPITable>
                                        }
                                        {
                                            this.state.dashboard && this.state.dashboard_data &&
                                            <KPITable title="Dashboard" counter={this.state.dashboard_data?.length}>
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <table className="table-kpi">
                                                    <thead>
                                                        <tr>
                                                            <th>Service</th>
                                                            <th>Date</th>
                                                            <th>Availability</th>
                                                            {/* <th>Duration</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.dashboard_data.map((d: any, key: number) => (
                                                                <tr key={key}>
                                                                    <td>{d.service}</td>
                                                                    <td>{d.date_time}</td>
                                                                    <td>{d.availability?.toString()}</td>
                                                                    {/* <td>{date_day_diff(d.start, d.stop || new Date().toISOString())}</td> */}
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </KPITable>
                                        }
                                    </>
                                }
                            </div>
                        }
                    ]}
                />



                <br />
                <br />
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>

                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />
                <a 
                    className={classNames({
                        "custom-button medium inline": true,
                        "disabled": !this.type_selected()
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }

    type_selected = () =>{
        return (this.state.api || this.state.dashboard)
    }

    download_url = () => {
        let params = [
            // 'expand=product,sensing_product',
            'export=true',
            `start_date=${this.state.startDate}`,
            `stop_date=${this.state.stopDate}`
        ];

        let exports = [];
        if(this.state.api) exports.push('API');
        if(this.state.dashboard) exports.push('dashboard');
        if(exports.length > 0) params.push(`exports=${exports.join(',')}`);

        if(this.state.json_format) params.push('format=json');
        
        return `${API_URL}/api/v1/dashboard?${params.join('&')}`
    }

    update_url = () =>{
        update_kpi_url(4, {
            startDate: to_local_iso_string(this.state.startDate),
            stopDate: to_local_iso_string(this.state.stopDate),
        })
    }

    on_zoom_complete = async(e: any) => {
        try {
            let start = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-0']?.min), true, true);
            let stop = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-0']?.max), true, true);
            await this.setState({
                startDate: start,
                stopDate: stop,
                updateStartDate: start,
                updateStopDate: stop
            })
            this.update_url()
            this.fetch_data()
        }
        catch (e) { }
    }

};

export default connect((state:any)=>{
    return {
        kpi: state.kpi
    }
})(KPI4)